import type {
  NFTMetadataInput,
  NFTMetadataOutput,
  NFTOptions,
  NFTPropertiesObject,
} from './nft.types';

const reduceProperties =
  (properties: NFTPropertiesObject) =>
  (acc: { [key: string]: any }, name: string) => {
    const property = properties[name];
    if (!property) {
      return acc;
    }
    return {
      ...acc,
      [name]: {
        type: property.type,
        description: property.value,
      },
    };
  };

export const generateNftMetadata = (
  options: NFTOptions,
  input: NFTMetadataInput,
): NFTMetadataOutput => {
  return {
    name: input.title,
    title: input.title,
    description: input.description,
    type: 'object',

    image: input.properties.image_url
      ? (input.properties.image_url.value as string)
      : '',

    animation_url: input.properties.animation_url
      ? (input.properties.animation_url.value as string)
      : undefined,

    background_color: input.properties.background_color
      ? (input.properties.background_color.value as string)
      : '',

    external_url: input.properties.external_url
      ? (input.properties.external_url.value as string)
      : '',

    properties: Object.keys(input.properties).reduce(
      reduceProperties(input.properties),
      {},
    ),
    attributes: input.attributes
      .filter(a => a !== undefined)
      .map(attribute => {
        return {
          display_type: attribute?.type === 'date' ? 'date' : undefined,
          trait_type: attribute?.label,
          value: attribute?.value,
        };
      }),
  };
};
